import { Button, IconArrowDown, IconArrowUp, IconHandle, Wrapper } from '@screentone/core';

import styles from './ReorderControls.module.scss';

interface ReorderControlsProps {
  isFirst: boolean;
  isLast: boolean;
  onMoveUp: () => void;
  onMoveDown: () => void;
  dragHandleProps?: object;
  dragHandleTestId?: string;
  dragHandleAriaLabel?: string;
}

export const ReorderControls = ({
  isFirst,
  isLast,
  onMoveUp,
  onMoveDown,
  dragHandleProps,
  dragHandleTestId,
  dragHandleAriaLabel
}: ReorderControlsProps) => (
  <Wrapper padding={{ all: 'sm' }} className={styles.container}>
    <Button tertiary disabled={isFirst} icon={IconArrowUp} onClick={onMoveUp} />
    <div
      {...(dragHandleTestId ? { 'data-testid': dragHandleTestId } : {})}
      {...(dragHandleAriaLabel ? { 'aria-label': dragHandleAriaLabel } : {})}
      {...dragHandleProps}
    >
      <IconHandle color="asphalt" />
    </div>
    <Button tertiary disabled={isLast} icon={IconArrowDown} onClick={onMoveDown} />
  </Wrapper>
);
